import { useResourceListStore, } from '@/assets/js/src/modules/resource/_pinia/resourceList'
import { getActivePinia, storeToRefs, } from 'pinia'
import { computed, ref, watch, } from 'vue'
import { mapUserOptionByPath, } from '@/assets/js/src/modules/user/_pinia/mapUserOptionByPath'
import { ERROR, LOADED, LOADING, UPDATING, } from '@/assets/js/src/util/composables/usePrefetchData'
import { DIR_LTR, DIR_RTL, } from '@/assets/js/src/modules/lang/_pinia/lang'
import { debounce, } from '@/assets/js/src/util/uiTools'

export function useVideoListFilter () {
    let resourceListStore = useResourceListStore(getActivePinia())
    let { books,search, } = storeToRefs(resourceListStore)

    // FILTER
    watch(books,()=>resourceListStore.reload = true)

    const abbreviations = computed(mapUserOptionByPath('resource/video/abbreviations'))
    watch(abbreviations,()=>resourceListStore.reload = true)

    const debouncedSearch = ref(search.value)
    watch(debouncedSearch,
        debounce((newVal) => search.value = newVal, 300),
        { immediate: !import.meta.env.SSR, })
    watch(search,()=>resourceListStore.reload = true)

    // SORT
    const sort = computed(mapUserOptionByPath('resource/video/sort'))
    watch(sort,()=>resourceListStore.reload = true)

    return {
        debouncedSearch,
        abbreviations,
        books,
        sort,
        LOADED,
        LOADING,
        UPDATING,
        ERROR,
        DIR_RTL,
        DIR_LTR,
    }
}
